import { render } from "./VideoGrid.vue?vue&type=template&id=05c4ddac"
import script from "./VideoGrid.vue?vue&type=script&lang=js"
export * from "./VideoGrid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dating-services.top/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__